<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-02-23 17:59:38
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-02 18:32:41
 * @FilePath: \seller.sviptrader.com\src\components\business\introduction\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="introduction">
		<el-popover placement="top-start" width="200" trigger="hover" popper-class="introduction-popover">
			<div class="ml-4">
				<div class="mb-8">
					<p class="font-h4-medium yx-color-text-primary"> 联系方式 </p>
				</div>
				<div class="yx-color-text-primary font-h6-regular">
					<p>
						<span class="color-gy-7">微信号</span>
						<span class="color-gy-9 ml-12">{{ wechat }}</span>
					</p>
					<p class="mt-2">
						<span class="color-gy-7">手机号</span>
						<span class="color-gy-9 ml-12">{{ mobile }}</span>
					</p>
				</div>
			</div>
			<span slot="reference" class="cursor-pointe ml-4r">
				<i class="i-introduction" style="width: 14px; display: inline-block"></i>
			</span>
		</el-popover>
	</div>
</template>
<script>
export default {
	props: {
		anchorId: {
			type: [String, Number],
			default: '',
		},
		wechat: {
			type: String,
			default: '',
		},
		mobile: {
			type: String,
			default: '',
		},
	},
	methods: {},
};
</script>
<style lang="less">
.introduction-popover {
	padding: 12px;
}
</style>
